module.exports = __webpack_public_path__ + "img/swissfortress.bdf8592a.png";